
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/2020-10-06-authentication-in-next-js-with-strapi-and-next-auth",
      function () {
        return require("private-next-pages/articles/2020-10-06-authentication-in-next-js-with-strapi-and-next-auth.mdx");
      }
    ]);
  